import React, { useContext, useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase/config';
import api from '../services/api';

const AutenticacaoContexto = React.createContext();

export function useAutenticacao() {
    return useContext(AutenticacaoContexto);
}

const getPerfilDoStorage = () => {
    try {
        const perfilSalvo = localStorage.getItem('perfilUsuario');
        return perfilSalvo ? JSON.parse(perfilSalvo) : null;
    } catch (error) {
        console.error("Erro ao ler perfil do localStorage", error);
        return null;
    }
};

export function ProvedorAutenticacao({ children }) {
    // ---- NOVOS ESTADOS ----
    const [usuarioFirebase, setUsuarioFirebase] = useState(null); // Guarda o usuário do Firebase (com o UID)
    const [perfilUsuario, setPerfilUsuario] = useState(getPerfilDoStorage()); // Guarda o perfil do nosso banco
    const [carregandoSessao, setCarregandoSessao] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (usuario) => {
            setCarregandoSessao(true);
            try {
                if (usuario) {
                    // 1. Guarda o objeto do Firebase
                    setUsuarioFirebase(usuario);

                    // 2. Busca o perfil do nosso backend
                    const resposta = await api.get('/api/usuarios/meu-perfil');
                    const perfilAtualizado = resposta.data;

                    setPerfilUsuario(perfilAtualizado);
                    localStorage.setItem('perfilUsuario', JSON.stringify(perfilAtualizado));

                } else {
                    // Se deslogou, limpa ambos os estados
                    setUsuarioFirebase(null);
                    setPerfilUsuario(null);
                    localStorage.removeItem('perfilUsuario');
                }
            } catch (error) {
                console.error("Falha na validação da sessão.", error);
                setUsuarioFirebase(null);
                setPerfilUsuario(null);
                localStorage.removeItem('perfilUsuario');
                await signOut(auth);
            } finally {
                setCarregandoSessao(false);
            }
        });

        return () => unsubscribe();
    }, []);

    // ---- NOVA FUNÇÃO ADICIONADA ----
    // Permite que a página de perfil force a recarga dos dados após uma atualização
    const carregarPerfil = async () => {
        try {
            const resposta = await api.get('/api/usuarios/meu-perfil');
            const perfilAtualizado = resposta.data;
            setPerfilUsuario(perfilAtualizado);
            localStorage.setItem('perfilUsuario', JSON.stringify(perfilAtualizado));
        } catch (error) {
            console.error("Erro ao recarregar perfil:", error);
        }
    };


    const logout = async () => {
        await signOut(auth);
    }

    // O valor do contexto agora inclui o usuarioFirebase e a função de recarregar
    const value = {
        usuarioFirebase, // <-- O objeto com o UID
        perfilUsuario,   // <-- O objeto do nosso banco
        carregandoSessao,
        logout,
        carregarPerfil, // <-- A nova função
    };

    return (
        <AutenticacaoContexto.Provider value={value}>
            {children}
        </AutenticacaoContexto.Provider>
    );
}